import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

const config = [
  {
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1100&q=80",
    cls: "md:col-span-7 min-h-[420px]",
    links: [{ slug: "family-office-dubai-difc" }],
  },
  {
    img: "https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=1100&q=80",
    cls: "md:col-span-5 min-h-[420px]",
    links: [{ slug: "family-office-switzerland" }],
  },
  {
    img: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1100&q=80",
    cls: "md:col-span-5 min-h-[420px]",
    links: [{ slug: "family-office-singapore" }],
  },
  {
    img: "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg?w=1100",
    cls: "md:col-span-7 min-h-[420px]",
    links: [{ slug: "family-office-london" }],
  },
];

export default function Jurisdictions() {
  const { t, lang } = useLanguage();
  const arrow = lang === "ar" ? "←" : "→";
  return (
    <section id="jurisdictions" data-testid="jurisdictions-section" className="bg-paper py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">{t.jurisdictions.overline}</p>
          <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-slate-950 mb-14 max-w-3xl">
            {t.jurisdictions.title1}<br />{t.jurisdictions.title2}
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {t.jurisdictions.items.map((j, i) => {
            const c = config[i];
            return (
              <Reveal key={j.name} delay={i * 0.08} className={c.cls}>
                <div
                  data-testid={`jurisdiction-card-${i}`}
                  className="group relative overflow-hidden rounded-[24px] bg-brand h-full min-h-[420px]"
                >
                  {/* Emerald-toned layer, revealed on hover */}
                  <img
                    src={c.img}
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 w-full h-full object-cover mix-blend-luminosity opacity-0 transition-all duration-500 group-hover:opacity-90 group-hover:scale-105"
                  />
                  {/* Full-colour photo, visible by default */}
                  <img
                    src={c.img}
                    alt={`Family office setup in ${j.name}`}
                    className="absolute inset-0 w-full h-full object-cover opacity-100 transition-opacity duration-500 group-hover:opacity-0"
                  />
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{ background: "linear-gradient(180deg, rgba(8,44,39,.15) 0%, rgba(8,44,39,.55) 55%, rgba(8,44,39,.92) 100%)" }}
                  />
                  <div className="relative p-8 lg:p-10 h-full flex flex-col justify-end text-white">
                    <h3 className="font-outfit text-2xl md:text-3xl font-medium mb-4">{j.name}</h3>
                    <ul className="space-y-2 mb-6">
                      {j.points.map((p) => (
                        <li key={p} className="text-sm text-white/80 flex items-start gap-2.5">
                          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand-300 shrink-0" />
                          <span>{p}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-wrap gap-x-6 gap-y-2 pt-1 border-t border-white/15">
                      {c.links.map((l, k) => (
                        <Link
                          key={l.slug}
                          to={`/${l.slug}`}
                          data-testid={`jurisdiction-guide-link-${i}-${k}`}
                          className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-brand-200 transition-colors"
                        >
                          {l.label || t.jurisdictions.guideLabel}
                          <span className="transition-transform group-hover:translate-x-0.5">{arrow}</span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
